<template>
  <v-dialog v-model="dialog" width="700px">
    <v-card v-if="ready === true">
      <p class=".title ma-2">Move {{huov.huov_ota_code}} to another booking</p>
      <v-form ref="huovInpt" v-model="huovInptValid">
        <v-row no-gutters>
            
          <v-col cols="6" class="px-1">
           <v-text-field v-model="huov_code_to" label="ARES booking code where the OTA code should move to" :rules="huov_to_codeRules"></v-text-field>
          </v-col> 
        </v-row>

      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary mx-2"
          small
          @click="updOtaCode"
          :disabled="!huovInptValid"
          >Save</v-btn
        >
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huovInptValid: false,
      ready: false,
      huov_code_to: '',
      huov_to_codeRules: [
          v => (v && v.length >= 9) || "A ARES booking code is mandatory"
      ],
      huov: {}
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovOtaCode.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovOtaCode",
          },
          getHuovOtaCode: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovOtaCode;
            this.ready = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updOtaCode() {
      this.$axios
        .post("ares/json/ares/huov/updOtaCode.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updOtaCode",
          },
          updOtaCode: {
            huov_encrid: this.huov.huov_encrid,
            huov_code_to: this.huov_code_to
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updOtaCode.text,
              color: res.data.updOtaCode.color,
            });
            if (res.data.updOtaCode.color == "success" || res.data.updOtaCode.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updOtaCode.huov_encrid); }, 1000); 
            }
            this.dialog = false;
          }
        });
    },
  }
  
};
</script>

